// extracted by mini-css-extract-plugin
export default {"reviewSection":"Reviews_reviewSection__qs-ew","title":"Reviews_title__L422g"};